import { Button, Col, Divider, Row } from 'antd';
import InvoiceCFEDownload from './InvoiceCFEDownload';
import InvoiceCFEUpload from './InvoiceCFEUpload';
import InvoiceCFESend from './InvoiceCFESend';
import InvoiceCFECancel from './InvoiceCFECancel';
import InvoiceCFEPrint from './InvoiceCFEPrint';
import ButtonBack from '@/components/_common/ButtonBack';
import { useRouteMatch } from 'react-router-dom';

const InvoiceCFEFooter: React.FC = () => {
  const { companyId } = useRouteMatch<{ companyId: string }>().params;

  return (
    <>
      <Divider />

      <Row gutter={[16, 16]}>
        <Col>
          <ButtonBack path={`/app/fiscal/coupon?companyId=${companyId}`} />
        </Col>

        <Col>
          <Button>Origem</Button>
        </Col>

        <Col>
          <InvoiceCFEDownload />
        </Col>

        <Col>
          <InvoiceCFEUpload />
        </Col>

        <Col>
          <InvoiceCFESend />
        </Col>

        <Col>
          <InvoiceCFECancel />
        </Col>

        <Col>
          <InvoiceCFEPrint />
        </Col>
      </Row>
    </>
  );
};

export default InvoiceCFEFooter;
